export class TipoSangue {
  id = 0;
  tipoSangue = '';
}
